import slugify from 'slugify';

export const slugLower = (str: string) =>
  slugify(str || '', {
    lower: true,
  }).replace(/_/g, '-');
